import {
  Column,
  ErrorText,
  LoadingIndicator,
  PlacementTabTable,
} from "@/components";

import { useUserSheet } from "@/components/user-sheet/userSheetContext";
import { cn } from "@/lib/utils";
import { CandidacyPlacement, Job } from "@/types";

export const PlacementsTab = ({
  isError,
  isPending,
  job,
  placements,
}: {
  isError: boolean;
  isPending: boolean;
  job?: Job;
  placements: CandidacyPlacement[];
}) => {
  /* Context */
  const { contentPaddingClassName } = useUserSheet();

  /* Render */
  const render = () => {
    if (isPending) {
      return (
        <Column className={cn("py-7", contentPaddingClassName)}>
          <LoadingIndicator variant="medium" />
        </Column>
      );
    }
    if (isError || !job) {
      return (
        <Column className={cn("py-7", contentPaddingClassName)}>
          <ErrorText errorMessage="Error retrieving placements." />
        </Column>
      );
    }

    return (
      <Column className={cn("py-7", contentPaddingClassName)}>
        <PlacementTabTable isCandidateSheet job={job} placements={placements} />
      </Column>
    );
  };

  return render();
};
